import React, { useState } from "react";
import Utils from "../../configs/Utils";
import Enums from "../../configs/Enums";
import { Button, Col, Form } from "react-bootstrap";

const StoreFilterForm = ({...props}) => {
  const { setFilter, setPage } = props;
  const [params, setParams] = useState({});

  const handleSearchForm = (e) => {
    e.preventDefault();
    let data = {...params};
    data[e.target.name] = e.target.value;
    setParams(data);
  }

  const handleSearchSubmitForm = (e) => {
    e.preventDefault();
    setPage(1);
    setFilter(params);
  }

  return (
    <Form className="mb-0" onChange={handleSearchForm} onSubmit={handleSearchSubmitForm}>
      <div className="d-flex gap-2 align-items-center">
        <Col md={3}>
          <Form.Control name="s" size="sm" type="search" placeholder="Store name, store url ..." />
        </Col>
        <Col md="auto">
          <Form.Select name="flatform" size="sm" defaultValue="">
            <option value="">All flatforms</option>
            <option value="woocommerce">Woocommerce</option>
            <option value="tiktokshop">Tiktok Shop</option>
            <option value="shopify">Shopify</option>
          </Form.Select>
        </Col>
        <Col md="auto">
          <Button type="submit" size="sm" variant="dark">Apply</Button>
        </Col>
      </div>
    </Form>
  );
}

export default StoreFilterForm;